var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav',{staticClass:"list bg-white"},_vm._l((_vm.availableItems),function(item){return _c('b-nav-item',{key:item.path,staticClass:"list-item",on:{"click":function($event){$event.stopPropagation();return _vm.openPage(item.path)}}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(item.title))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }